import { useParams } from 'react-router-dom';
import useDedicatedFileUpload from './useDedicatedFileUpload';
import { prepFileDataForDedicatedUpload } from '../utils/helper';
import { RECORD_DATA_TYPE, MEDICAL_PROVIDER_TYPE } from '@demandproai/shared';

/**
 * Shared dedicated-upload flow for medical records used by both the manual
 * per-provider UI and the AI default bucket. Tags every file with its timing
 * (isPost) so the resulting CaseRecord self-describes which bucket it came from.
 * @param {Object} params
 * @param {MEDICAL_PROVIDER_TYPE[keyof MEDICAL_PROVIDER_TYPE]} params.providerType - timing section
 * @returns {{ uploadMedicalRecords: Function, isLoading: boolean }}
 */
const useMedicalFileUpload = ({ providerType }) => {
  const { caseId } = useParams();
  const { dedicatedFileUpload, isLoading, completeFileUpload, startFileUpload } = useDedicatedFileUpload(caseId, RECORD_DATA_TYPE.MEDICAL);

  const uploadMedicalRecords = async (validFiles, updateCasePayload = null) => {
    const prepFiles = prepFileDataForDedicatedUpload(validFiles).map((file) => ({
      ...file,
      metaData: { ...file.metaData, isPost: providerType === MEDICAL_PROVIDER_TYPE.POST_ACCIDENT }
    }));
    const fileCount = prepFiles.length;
    startFileUpload(fileCount);
    const dedicatedFiles = await dedicatedFileUpload(prepFiles, updateCasePayload);
    completeFileUpload(fileCount);
    return dedicatedFiles;
  };

  return { uploadMedicalRecords, isLoading };
};

export default useMedicalFileUpload;
